import { render, staticRenderFns } from "./partTimeStudentDialog.vue?vue&type=template&id=4e9e88ef&"
import script from "./partTimeStudentDialog.vue?vue&type=script&lang=js&"
export * from "./partTimeStudentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports